import PhotoUploadStep from './PhotoUploadStep';

export default PhotoUploadStep;
